import * as t from './actionTypes';
import * as api from './api';

export function loadRewards(successCB, errorCB) {
  return (dispatch) => {
    api.getRewards(function (success, rewards, error) {
      if (success) {
        dispatch({ type: t.REWARD_LOAD_SUCCESS, rewards: rewards });
        successCB();
      } else if (error)
        errorCB(error);
    })
  }
}

export function getUserData(successCB, errorCB) {
  return (dispatch) => {
    api.getUserData(function (success, data, error) {
      if (success) {
        dispatch({ type: t.GET_USER_DATA, data: data});
        successCB();
      }
      else {
        errorCB(error);
      }
    })
  }
}

export function createNewReward(data, successCB, errorCB) {
  return (dispatch) => {
    api.createNewReward(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.REWARD_CREATE_SUCCESS, reward: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function updateReward(id, data, cb) {
    return (dispatch) => {
        api.updateReward(id, data, function(error) {
            cb(error);
        })
    }
}

export function deleteReward(id, cb) {
    return (dispatch) => {
        api.deleteReward(id, function(success, data, error) {
            cb();
        })
    }
}

export function sendOneTime(data, successCB, errorCB) {
  return (dispatch) => {
    api.sendOneTime(data, function(success, data, error) {
      if (success) {
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function getSettings(cb) {
  return dispatch => {
    api.getSettings(function (settings) {
      dispatch({ type: t.SETTINGS_LOAD_SUCCESS, settings: settings });
      cb(settings)
    });
  }
}

export function saveRewardSettings(data, cb) {
  return dispatch => {
    api.updateSettings(data, function (settings) {
      cb(settings)
    });
  }
}
